import { AspectRatioType } from '../../utils/aspect-ratio';

export type GenerateSrcOptionsType = {
  width: number;
  height: number;
  url: string;
  aspectRatio: AspectRatioType;
  hasDarkeningLayer?: boolean;
};

export const presetName = '$smartResponsiveHiDPI$';
const darkeningLayerParam = '&layer=1&bgColor=0,0,0,46&sizeN=100,100';

export const generateSrc = (options: GenerateSrcOptionsType): string => {
  const { width, url, height, aspectRatio, hasDarkeningLayer } = options;

  return `${url}:${aspectRatio}?${presetName}&wid=${Math.round(width)}&hei=${Math.round(height)}${
    hasDarkeningLayer ? darkeningLayerParam : ''
  }`;
};
